import {
    tools,
    storage
} from '../utils/tools'
import EZUIKit from 'ezuikit-js';
import _getUserInfo from './apis/getUserInfo'
import axios from 'axios'
import {
    EventEmitter
} from '../EventEmitter'
import {
    getDeviceVideo,
    addDeviceVideo,
    deleteDeviceVideo,
    editDeviceVideo,
    reloadDeviceVideo
} from './apis/project.js'
/**
 * @class
 * @classdesc 设置
 */
export default class Setting extends EventEmitter {

    playUrl = 'https://open.ys7.com/api/lapp/v2/live/address/get';
    constructor(proc) {
        super(proc)
        this.data = proc.data;
        this.proc = proc;
    }

    /*删除视频监控*/
    async deleteVideo(id) {
        const device = this.data.device
        const result = await deleteDeviceVideo(device.groupId, device.deviceSn, id)
        return result;
    }

    /*播放视频*/
    playVideo(el, accessToken, url) {
        const player = new EZUIKit.EZUIKitPlayer({
            id: el, // 视频容器ID
            accessToken,
            url,
            audio: 0,
            // template:'security'
        })
        console.log(player)
        return player;

    }

    /**
     * 获取设备视频
     */
    async getVideos() {
        const device = this.data.device
        const result = await getDeviceVideo(device.groupId, device.deviceSn);
        return result.data;
    }

    /**
     * 设置视频配置
     */
    async setVideos(data) {
        const device = this.data.device
        const result = await addDeviceVideo(device.groupId, device.deviceSn, data)
        return result
    }

    /*编辑监控*/
    async editVideo(data){
        const device = this.data.device
        const result = await editDeviceVideo(device.groupId, device.deviceSn, data)
        return result;
    }
    /*刷新监控*/
    async reloadVideo(id){
        const device = this.data.device
        return await reloadDeviceVideo(device.groupId, device.deviceSn,id)
    }

}